import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Scharnier from "../../doors/scharnier";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import { nullRotation } from "../double-scharnier";

interface DoubleScharnierSinglePanelProps extends ConfigurationProps {}
const DoubleScharnierSinglePanel: React.FC<DoubleScharnierSinglePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleScharnierSinglePanelProps) => {
  const position0 = new Vector3(-0.47, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);

  const {
    eigenwijs,
    getConfigurationPositions,
    isDoubleHandleChosen,
    isDoubleJHandle,
  } = useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1, position2]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Scharnier
        materials={materials}
        position={positions[0]}
        rotation={isDoubleHandleChosen ? nullRotation : rotation}
        secondary={true}
        index={0}
        lockSettings={doorSettings?.secondary?.lockSettings}
        frameSettings={doorSettings?.secondary?.frameSettings}
        kozijnSettings={doorSettings?.secondary?.kozijnSettings}
        secondaryDoorDoubleJHandle={isDoubleJHandle}
      />
      <Scharnier
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.main?.frameSettings}
        lockSettings={doorSettings?.main?.lockSettings}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
      />
      <Paneel materials={materials} position={positions[2]} index={2} />
    </group>
  );
};

export default DoubleScharnierSinglePanel;
